<template>
    <div class="add_management_wrapper">
        <div class="company_container">
            <!-- 头部 -->
            <div class="title_type">
                <div class="title_class">
                    <span style="color: #ef3737">*</span>投保人类型
                </div>
                <van-radio-group
                    :disabled="btnFlag"
                    v-model="radio"
                    direction="horizontal"
                    icon-size="0.3rem"
                    checked-color="#28CC77"
                >
                    <van-radio name="0">企业</van-radio>
                    <van-radio name="1">个人</van-radio>
                </van-radio-group>
            </div>
            <!-- 投保人类型：企业 -->
            <div v-if="radio == 0">
                <div class="input_item">
                    <div class="title_class">
                        <span style="color: #ef3737">*</span>公司名称
                    </div>
                    <div class="value_class">
                        <input
                            type="text"
                            v-model="companyName"
                            placeholder="请输入公司名称"
                            placeholder-class="title"
                            class="input_class"
                        />
                    </div>
                </div>
                <div class="input_item">
                    <div class="title_class">
                        <span style="color: #ef3737">*</span>证件类型
                    </div>
                    <div class="value_class">
                        <div>统一社会信用代码</div>
                        <div class="iconfont icon-arrow" style="margin-left: 0.14rem"></div>
                    </div>
                </div>
                <div class="input_item">
                    <div class="title_class">
                        <span style="color: #ef3737">*</span>统一社会信用代码
                    </div>
                    <div class="value_class">
                        <input
                            type="text"
                            v-model="companyCreditNumber"
                            placeholder="请输入信用代码"
                            placeholder-class="title"
                            class="input_class"
                        />
                    </div>
                </div>
                <div class="input_item" @click="show = true">
                    <div class="title_class">
                        <span style="color: #ef3737">*</span>省市区
                    </div>
                    <div class="value_class">
                        <div
                            :style="companyArea == '' ? 'color:#999' : 'color:#333'"
                        >{{ companyArea == '' ? '请选择省市区' : companyArea }}</div>
                    </div>
                </div>
                <van-popup v-model="show" position="bottom">
                    <van-area
                        :area-list="areaList"
                        @confirm="changeArea"
                        @cancel="show = false"
                        :value="initArea"
                    />
                </van-popup>
                <div class="input_item">
                    <div class="title_class">
                        <span style="color: #ef3737">*</span>公司地址
                    </div>
                    <div class="value_class">
                        <input
                            type="text"
                            v-model="companyAddress"
                            placeholder="请输入公司地址"
                            placeholder-class="title"
                            class="input_class"
                        />
                    </div>
                </div>
                <div class="item" style="padding: 0rem 0.2rem">
                    <div>设为默认地址</div>
                    <van-switch
                        v-model="switchChecked"
                        size="20"
                        active-color="#28CC77"
                        inactive-color="#ccc"
                    />
                </div>
            </div>
            <!-- 投保人类型：个人 -->
            <div v-else>
                <div class="btn_box">
                    <div class="btn_item">手动输入</div>
                    <div class="btn_item" @click="goWriteInfo">身份证识别</div>
                </div>
                <div class="input_item">
                    <div class="title_class">
                        <span style="color: #ef3737">*</span>姓名
                    </div>
                    <div class="value_class">
                        <input
                            type="text"
                            v-model="personalName"
                            placeholder="请输入投保人姓名"
                            placeholder-class="title"
                            class="input_class"
                        />
                    </div>
                </div>
                <div class="input_item" @click="showPicker = true">
                    <div class="title_class">
                        <span style="color: #ef3737">*</span>证件类型
                    </div>
                    <div class="value_class">
                        <input
                            v-if="!idType"
                            type="text"
                            readonly
                            placeholder="请选择证件类型"
                            placeholder-class="title"
                            class="input_class"
                        />
                        <div v-else>{{ idType }}</div>
                        <div class="iconfont icon-arrow" style="margin-left: 0.14rem"></div>
                    </div>
                </div>
                <van-popup v-model="showPicker" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="typeList"
                        value-key="value"
                        :default-index="initIndex"
                        @confirm="changePicker"
                        @cancel="showPicker = false"
                    />
                </van-popup>
                <div class="input_item">
                    <div class="title_class">
                        <span style="color: #ef3737">*</span>证件号码
                    </div>
                    <div class="value_class">
                        <input
                            type="text"
                            v-model="personalNumber"
                            placeholder="请输入证件号码"
                            placeholder-class="title"
                            class="input_class"
                        />
                    </div>
                </div>
                <div class="input_item">
                    <div class="title_class">
                        <span style="color: #ef3737">*</span>手机号码
                    </div>
                    <div class="value_class">
                        <input
                            type="number"
                            v-model="personalTel"
                            placeholder="请输入手机号"
                            placeholder-class="title"
                            class="input_class"
                        />
                    </div>
                </div>
                <div class="item" style="padding: 0rem 0.2rem">
                    <div>设为默认地址</div>
                    <van-switch
                        v-model="switchChecked"
                        size="20"
                        active-color="#28CC77"
                        inactive-color="#ccc"
                    />
                </div>
            </div>
        </div>
        <div class="btn" @click="handleConfirm">保存</div>
    </div>
</template>

<script>
import "./AddManagement.less";
import provinceList from "./../../libs/js/areaList";
import { verifyCardNo, isMobile } from "../../utils/verifyUtils";
import {
    Picker,
    Switch,
    RadioGroup,
    Radio,
    Area,
    Popup,
    Notify,
    Toast,
} from "vant";

export default {
    name: "AddManagement",
    data() {
        return {
            radio: "0", // 默认勾选企业 注意是字符串0
            companyName: "", // 公司名称
            companyCreditNumber: "", // 信用编号
            companyArea: "", // 省市区
            companyAddress: "", // 公司地址
            show: false,
            personalName: "", // 投保人姓名
            idType: "", // 证件类型
            personalNumber: "", // 证件号码
            personalTel: "", // 手机号码
            areaList: provinceList,
            switchChecked: "", // 默认地址开关
            showPicker: false, // 弹框开关
            userCardId: "", // 证件类型Id，身份证为1
            btnFlag: false, // 禁用按钮
            initIndex: 0, // 个人证件类型初始选中项的索引，默认身份证
            initArea: "110000", // 企业地址省市区初始选中项code，默认北京市
            typeList: [
                { id: 1, value: "身份证" },
                { id: 2, value: "军官证" },
                { id: 3, value: "护照" },
                { id: 4, value: "驾驶证" },
                { id: 5, value: "营业执照" },
                { id: 6, value: "其他" },
            ],
        };
    },
    components: {
        "van-radio": Radio,
        "van-radio-group": RadioGroup,
        "van-area": Area,
        "van-popup": Popup,
        "van-switch": Switch,
        "van-picker": Picker,
    },
    mounted() {
        this.getQuery();
    },
    methods: {
        // 跳转身份证验证
        goWriteInfo() {
            this.$router.push("/writeInformation");
        },
        getQuery() {
            const { type, holderType, holderId } = this.$route.query;
            // console.log(type); 操作类型-编辑操作 0
            // console.log(holderType); 投保人类型 1
            // console.log(holderId); 投保人Id 2
            if (type == 0) {
                // 如果是编辑操作，禁用按钮
                this.btnFlag = true;
                // 根据投保人Id渲染编辑页面的投保人信息
                if (holderId == 2) {
                    console.log(2);
                    if (holderType == 0) {
                        // 企业
                        // 调接口
                        const testObj = {
                            companyName1: "大树保公司",
                            companyCreditNumber1: "1234567890",
                            companyArea1: "河南省-郑州市-中原区",
                            companyAddress1: "科技园7栋205",
                            initArea1: "410000",
                        };
                        const {
                            companyName1,
                            companyCreditNumber1,
                            companyArea1,
                            companyAddress1,
                            initArea1,
                        } = testObj;
                        // 更新页面数据
                        this.companyName = companyName1;
                        this.companyCreditNumber = companyCreditNumber1;
                        this.companyArea = companyArea1;
                        this.companyAddress = companyAddress1;
                        this.initArea = initArea1; // 地区对应code
                    } else if (holderType == 1) {
                        // 个人
                        // 调接口
                        const testObj1 = {
                            personalName1: "张三",
                            idType1: "护照",
                            personalNumber1: "450123456789",
                            personalTel1: "19977182210",
                            initIndex1: 2,
                        };
                        // bug——修改常用投保人（个人）时，点击保存后提示请选择投保人证件类型，解决方法——根据证件类型修改证件id
                        this.userCardId = testObj1.initIndex1;

                        const {
                            personalName1,
                            idType1,
                            personalNumber1,
                            personalTel1,
                            initIndex1,
                        } = testObj1;
                        // 更新页面数据
                        this.personalName = personalName1;
                        this.idType = idType1;
                        this.personalNumber = personalNumber1;
                        this.personalTel = personalTel1;
                        this.initIndex = initIndex1; // 护照对应的索引
                    }
                }
            }
            // 切换按钮的勾选类型，默认为企业
            if (holderType == 1) {
                // 个人
                this.radio = "1";
            }
        },
        changeArea(values) {
            console.log(values);
            this.companyArea = values
                .filter((item) => !!item)
                .map((item) => item.name)
                .join("-");
            this.show = false;
            // console.log(this.companyArea);
        },
        changePicker(value) {
            this.idType = value.value;
            this.userCardId = value.id;
            this.showPicker = false;
        },

        // 点击立即投保
        handleConfirm() {
            const errMsg = this.verifyFormData();
            if (errMsg) {
                Notify(errMsg);
            } else {
                console.log("验证成功");
                Toast("保存成功");

                setTimeout(() => {
                    this.$router.go(-1);
                }, 1000);
            }
        },

        // 投保人表单校验
        verifyFormData() {
            const {
                companyName,
                companyCreditNumber,
                companyArea,
                companyAddress,
                personalName,
                personalNumber,
                personalTel,
                userCardId,
            } = this.$data;
            // 企业投保校验
            if (this.radio === "0") {
                const verifyRules = [
                    {
                        errMsg: "请输入公司名称",
                        value: companyName,
                        type: "companyName",
                    },
                    {
                        errMsg: "请输入信用代码",
                        value: companyCreditNumber,
                        type: "companyCreditNumber",
                    },
                    {
                        errMsg: "请选择省市区",
                        value: companyArea,
                        type: "companyArea",
                    },
                    {
                        errMsg: "请输入公司地址",
                        value: companyAddress,
                        type: "companyAddress",
                    },
                ];
                return this.getErrorMsg(verifyRules);
            } // 个人投保校验规则
            let verifyRules = [];
            if (userCardId > 1) {
                verifyRules = [
                    {
                        errMsg: "请输入投保人姓名",
                        value: personalName,
                        type: "personalName",
                    },
                    {
                        errMsg: "请选择投保人证件类型",
                        value: userCardId,
                        type: "userCardId",
                    },
                    {
                        errMsg: "请输入投保人的证件号码",
                        value: personalNumber,
                        type: "personalNumber",
                    },
                    {
                        errMsg: "请输入投保人手机号",
                        value: personalTel,
                        verifyMsg: "手机号格式不正确",
                        type: "personalTel",
                    },
                ];
                return this.getErrorMsg(verifyRules);
            } else {
                verifyRules = [
                    {
                        errMsg: "请输入投保人姓名",
                        value: personalName,
                        type: "personalName",
                    },
                    {
                        errMsg: "请选择投保人证件类型",
                        value: userCardId,
                        type: "userCardId",
                    },
                    {
                        errMsg: "请输入投保人的证件号码",
                        value: personalNumber,
                        verifyMsg: "身份证格式不正确",
                        type: "personalNumber",
                    },
                    {
                        errMsg: "请输入投保人手机号",
                        value: personalTel,
                        verifyMsg: "手机号格式不正确",
                        type: "personalTel",
                    },
                ];
                return this.getErrorMsg(verifyRules);
            }
        },

        // 错误信息提示
        getErrorMsg(verifyRules) {
            let errorArray = [];
            verifyRules.map((item) => {
                // 判断值是否为空
                if (!item.value) {
                    errorArray.push(item.errMsg);
                } else if (item.verifyMsg) {
                    // 值不为空时，判断是否有属性名verifyMsg，如果有，验证手机号和身份证号是否正确

                    // 验证身份证号
                    if (item.type === "personalNumber") {
                        // 引入第三方库verifyCardNo
                        const personalIdCardNum = verifyCardNo(item.value);
                        if (typeof personalIdCardNum !== "boolean") {
                            errorArray.push(item.verifyMsg);
                        }
                    }
                    // 验证手机号
                    if (item.type === "personalTel") {
                        // 引入第三方库isMobile
                        const personalPhoneNum = isMobile(item.value);
                        if (!personalPhoneNum) {
                            errorArray.push(item.verifyMsg);
                        }
                    }
                }
            });
            // 如果数组为空，即验证没有错误，返回false
            if (!errorArray.length) return false;
            // 返回第一个错误信息
            return errorArray[0];
        },
    },
};
</script>

